import React, { useState, useEffect } from 'react';
import { useData, useSettings } from '../context/store';
import Moment from 'moment';

// Same trip types as trip page dates-rates: show "Upon Request" (no availability from API).
const CRUISE_TRIP_TYPES = ['Cruise', 'River Cruise', 'Cruise Collection'];

/**
 * Compute space status from one departure (same logic as trip-tabs dates-rates TabContents).
 * Uses same source: wp-json/trip-finder/dates-rates response.
 */
function getSpaceStatusFromDeparture(departure) {
	const passengersAvailable = (departure.MaxPax || 0) - (departure.TotalPaxBooked || 0);
	const roomsAvailable = (departure.MaxRooms || 0) - (departure.TotalRoomsBooked || 0);
	const status = departure.DepartureStatus || '';

	if (status === 'Closed') return 'Closed';
	if (status === 'Blocked' || status === 'Sold Out') return 'Sold Out';
	if (roomsAvailable > 2 && passengersAvailable > 4) return 'Space Available';
	if ((roomsAvailable >= 1 && roomsAvailable < 3 && passengersAvailable > 0) || (passengersAvailable >= 1 && passengersAvailable < 5 && roomsAvailable > 0)) return 'Limited Availability';
	if (roomsAvailable <= 0 || passengersAvailable <= 0) return 'Sold Out';
	return 'Space Available';
}

const Activities = function (props) {
	if (props.activities.length) {
		return (
			<div className="tf-post__activities">
				{props.activities.map((activity) => {
					return (
						<div
							className="tf-post__activity"
							key={activity.name}
							dangerouslySetInnerHTML={{ __html: activity.name }}
						/>
					);
				})}
			</div>
		);
	}

	return '';
};

const TripType = function (props) {
	if (props.type.length) {
		return (
			<div className="tf-post__activities">
				<div
					className="tf-post__activity"
					dangerouslySetInnerHTML={{ __html: props.type }}
				/>
			</div>
		);
	}

	return '';
};

const Reviews = function (props) {
	if (props.trustpilotSku.length) {
		return (
			<div className="tf-post__reviews">
				<div
					className="trustpilot-widget"
					data-locale="en-US"
					data-template-id="54d39695764ea907c0f34825"
					data-businessunit-id="57c748920000ff00059427a1"
					data-style-height="24px"
					data-style-width="100%"
					data-theme="light"
					data-sku={props.trustpilotSku}
					data-star-color="#00b67a"
					data-no-reviews="hide"
					data-scroll-to-list="false"
				></div>
			</div>
		);
	}

	return '';
};

const DisplayCard = function (props) {
	const settings = useSettings();
	const newTrip = props.post._source.trip_info.new_trip;
	const cardDestinations = props.post._source.country_destinations;
	const cardLevel = props.post._source.trip_info.trip_level;
	const tripType = props.post._source.trip_info.trip_type;
	// console.log('post ', props.post);
	let cardLevelDiv = '';
	let cardDestinationsDiv = '';
	let newTripDiv = '';
	let tripTypeDiv = '';

	let tripPrice = props.post._source.trip_info.price;
	let tripPriceNext = props.post._source.trip_info.price_next;
	let pricingString = '';
	// console.log('check this.. ', props.post._source);

	if (tripPrice !== '0' && tripPrice !== '') {
		pricingString = (
			<p className="has-t-5-font-size">
				From{' $'}{parseInt(tripPrice).toLocaleString()}
			</p>
		);
	} else if (tripPriceNext !== '0' && tripPriceNext !== '') {
		pricingString = (
			<p className="has-t-5-font-size">
				From{' $'}{parseInt(tripPriceNext).toLocaleString()}
			</p>
		);
	} else {
		pricingString = (
			<p className="has-t-5-font-size">
				Call for Pricing
			</p>
		);
	}

	if (newTrip) {
		newTripDiv = (
			<p className="trip-chip has-overline-font-size">NEW TRIP</p>
		);
	}

	if (cardDestinations && cardDestinations.length > 0) {
		// console.log('card d ', cardDestinations);
		const destinationNames = cardDestinations.map(destination => destination.name);
		cardDestinationsDiv = (
			<div className="icon-text">
				<span
					title="location icon"
					className="icon-text__icon icon-communication"
				></span>
				<p className="icon-text__title is-style has-subtitle-1-font-size">
					{destinationNames.join(', ')}
				</p>
			</div>
		);
	}


	if (cardLevel) {
		cardLevelDiv = (
			<div className="icon-text">
				<span
					title="level icon"
					className="icon-text__icon icon-level"
				></span>
				<p className="icon-text__title is-style has-subtitle-1-font-size">
					Level {cardLevel[0].name}
				</p>
			</div>
		);
	}

	if (tripType) {
		tripTypeDiv = (
			<p className="extend-your-trip__chip-enabled has-t-6-font-size">
				{props.post._source.trip_info.trip_type}
			</p>
		);
	}

	const dateDiv = (
		<div className="icon-text">
			<span
				title="calendar icon"
				className="icon-text__icon icon-calendar"
			></span>
			<p className="icon-text__title is-style has-subtitle-1-font-size">
				{props.post._source.trip_info.days} days
			</p>
		</div>
	);

	const title = props.post._source.trip_info.title;
	const fixedStr = title.replace(/\\u([\dA-F]{4,6})/gi, (_, hex) =>
		String.fromCodePoint(parseInt(hex, 16))
	  );
	return (
		<a href={props.post._source.trip_info.link} className="extend-your-trip__slide" key={props.theIndex}>
			<div className="extend-your-trip__image">
				{newTripDiv}
				<figure
					className="main-image-bg"
					dangerouslySetInnerHTML={{
						__html: props.post._source.trip_info.img,
					}}
				></figure>
			</div>
			<div className="extend-your-trip__mid-content">
				{tripTypeDiv}
				<p className="has-t-3-larger-font-size">
					{fixedStr.replace(/&apos;|&#8217;/g, "’")}
				</p>
				{cardDestinationsDiv}
				{cardLevelDiv}
				{dateDiv}
			</div>
			<div className="extend-your-trip__bottom-callout">
				<div className="extend-your-trip__price">
					{pricingString}
				</div>
				<div className="extend-your-trip__link">
					<span
						className="has-button-2-font-size"
					>
						VIEW TRIP
					</span>
				</div>
			</div>
		</a>
	);
};

export default function Posts(props) {
	const state = useData();
	const settings = useSettings();
	const [availabilityMap, setAvailabilityMap] = useState({});
	const [availabilityLoading, setAvailabilityLoading] = useState(false);

	const posts =
		'undefined' !== typeof props.posts ? props.posts : state.posts;

	/**
	 * AVAILABILITY COLUMN (View by Date) — Why "Loading…" appears
	 *
	 * The table shows search results immediately (from Elasticsearch). Availability is NOT in the index;
	 * it comes from the same source as the trip page: wp-json/trip-finder/dates-rates (Tourcube).
	 *
	 * We fetch it here after the table renders: one request per unique trip_id in the results.
	 * With 15–20 different trips that can take 3–4 seconds, so we show "Loading…" until responses arrive.
	 *
	 * ALTERNATIVE (if loading is not acceptable):
	 * Enrich the search response in the backend (class-trip-finder.php). When sort_by=date, the PHP
	 * would call Tourcube (or dates-rates) for each unique trip_id and add availability to each record
	 * before sending the response. Then the table would render once with availability already filled.
	 * Implications: search response becomes slower (N server-side calls to Tourcube per request),
	 * and the same "space status" logic would need to be kept in PHP. Optional: add server-side cache
	 * by trip_id to reduce Tourcube load.
	 */
	useEffect(() => {
		if (state.sortBy !== 'date' || !posts || posts.length === 0 || typeof WP === 'undefined' || !WP.siteUrl) {
			setAvailabilityMap({});
			setAvailabilityLoading(false);
			return;
		}
		const cruiseSet = new Set(CRUISE_TRIP_TYPES);
		const uniqueTripIds = [...new Set(
			posts
				.filter(p => !cruiseSet.has(p._source?.trip_info?.trip_type))
				.map(p => p._source?.trip_info?.tripID)
				.filter(id => id != null && id !== 0)
		)];
		if (uniqueTripIds.length === 0) {
			setAvailabilityMap({});
			setAvailabilityLoading(false);
			return;
		}
		setAvailabilityLoading(true);
		const baseUrl = `${WP.siteUrl}/wp-json/trip-finder/dates-rates`;
		let cancelled = false;
		const newMap = {};
		Promise.all(
			uniqueTripIds.map(tripId =>
				fetch(`${baseUrl}?trip_id=${tripId}`)
					.then(res => res.json())
					.then(data => {
						if (cancelled) return;
						const deps = data.departures;
						if (!deps) return;
						const depList = Array.isArray(deps) ? deps : Object.keys(deps).map(k => deps[k]);
						depList.forEach(dep => {
							const date = dep.Departure_Date || '';
							if (date) {
								newMap[`${tripId}_${date}`] = getSpaceStatusFromDeparture(dep);
							}
						});
					})
					.catch(() => {})
			)
		).then(() => {
			if (!cancelled) {
				setAvailabilityMap(prev => ({ ...prev, ...newMap }));
				setAvailabilityLoading(false);
			}
		});
		return () => { cancelled = true; };
	}, [state.sortBy, posts]);

	if (true === state.loading && 1 === state.currentPage) {
		return <div className="tf-posts tf-posts--loading"></div>
	}

	const renderTrustpilotWidgets = function () {
		if (window.Trustpilot) {
			const widgets = document.querySelectorAll(
				'.tf-post__reviews .trustpilot-widget'
			);
			[...widgets].forEach((widget) => {
				window.Trustpilot.loadFromElement(widget);
			});
		}
	};

	const formatDateString = function (dateSource) {
		const startTime = Moment.unix(dateSource.departure_time).utc();
		const endTime = Moment.unix(dateSource.end_time).utc();

		let timeString =
			Moment(startTime).format('MMM D-');

		if (
			Moment(startTime).format('MMM') ===
			Moment(endTime).format('MMM')
		) {
			timeString +=
				Moment(endTime).format('D, YYYY');
		} else {
			timeString +=
				Moment(endTime).format('MMM D, YYYY');
		}

		return timeString;
	};

	if ('undefined' !== typeof state && posts.length) {
		const DestinationDiv = function (props) {
			if (props.name !== '') {
				return (
					<h3 className="tf-posts__destination-title">
						{props.name}
					</h3>
				);
			}
			return '';
		};

		if ('default' === state.sortBy) {
			const order = [36, 3519, 197, 962];
			
			const sortedPosts = posts.sort(
				(a, b) => order.indexOf(a._source.tax.tc_type[0]) - order.indexOf(b._source.tax.tc_type[0])
			);

			const featuredPosts = sortedPosts.filter(post => post._source.featured === '1');
			const notFeaturedPosts = sortedPosts.filter(post => post._source.featured !== '1');

			const finalPosts = featuredPosts.concat(notFeaturedPosts);

			return (
				<div className="tf-posts other-trips extend-your-trip">
					{finalPosts.map((post, index) => {
						return <DisplayCard post={post} theIndex={index} key={index} />;
					})}
				</div>
			);
		}

		if ('destination' === state.sortBy) {
			let lastTaxTitle = '';
			let lastTaxTitleDiv = '';
			let firstCountries = {};
			let firstTitle = '';
			let taxTerms = [];
			let firstCountry = 'A';
			let lastCountry = 'ZZZ';
			let typeTermIds = [];

			if (state.taxonomies && state.taxonomies.length > 0) {
				const tcTypeTax = state.taxonomies.find(taxonomy => taxonomy.name === 'tc_type');

				if (tcTypeTax && tcTypeTax.terms.length > 0) {
					typeTermIds = tcTypeTax.terms.map((taxTerm) => {
						return taxTerm.term_id;
					});
				}
			}

			posts.forEach((post) => {
				if (post._source.country_destinations && post._source.country_destinations.length > 0) {
					let firstDestinationName = '';

					post._source.country_destinations.forEach((destination) => {
						if (firstDestinationName === '' || (destination.name !== null && destination.name < firstDestinationName)) {
							firstDestinationName = destination.name;
						}
					});

					if (firstDestinationName !== '' && !firstCountries[firstDestinationName]) {
						firstCountries[firstDestinationName] = firstDestinationName;
					}
				}
			});

			if (firstCountries) {
				const firstCountryNames = Object.keys(firstCountries).sort();
				firstCountry = firstCountryNames[0];
				lastCountry = firstCountryNames[firstCountryNames.length - 1];
			}

			if (Object.keys(state.taxonomies).length !== 0) {
				state.taxonomies.map((taxonomy) => {
					if (taxonomy.name === 'tc_destinations') {
						let selectedCountries = [];
						let nonCountriesSelected = false;

						if (state.selectedTaxonomies && state.selectedTaxonomies.tc_destinations && state.selectedTaxonomies.tc_destinations.length > 0) {
							state.selectedTaxonomies.tc_destinations.forEach((selectedDestination) => {
								let selectedtaxTermObj = taxonomy.terms.find(term => term.term_id === selectedDestination);

								if (selectedtaxTermObj && selectedtaxTermObj.destination_type && selectedtaxTermObj.name && 'Country' === selectedtaxTermObj.destination_type) {
									selectedCountries.push(selectedtaxTermObj.name);
								} else {
									nonCountriesSelected = true;
								}
							});
						}

						taxonomy.terms.forEach((taxTermObj) => {
							if (taxTermObj.destination_type && 'Country' === taxTermObj.destination_type) {
								const taxTermFirstCountry = taxTermObj.name;

								if (taxTermFirstCountry >= firstCountry && taxTermFirstCountry <= lastCountry && (selectedCountries.length === 0 || selectedCountries.includes(taxTermFirstCountry) || nonCountriesSelected)) {
									taxTerms.push(taxTermObj);
								}
							}
						});
					}
				});

				if (taxTerms.length > 0) {
					firstTitle = taxTerms[0].name;
				}
			}

			if (typeTermIds.length > 0) {
				posts.sort((a, b) => {
					const aTcType = a._source.tax.tc_type[0];
					const bTcType = b._source.tax.tc_type[0];

					const aIndex = typeTermIds.indexOf(aTcType);
					const bIndex = typeTermIds.indexOf(bTcType);

					return aIndex - bIndex;
				});
			}

			taxTerms.sort(
				(a, b) => {
					if (a.name < b.name) {
						return -1;
					} else if (a.name > b.name) {
						return 1;
					}

					return 0;
				}
			);

			return (
				<div className="tf-posts">
					{taxTerms.map((taxTerm) => {
						{
							return posts.map((post, index) => {
								if (post._source.searchable_destinations) {
									// console.log(
									// 	'searchable ',
									// 	post._source.id,
									// 	post._source.searchable_destinations
									// );

									if (
										post._source.searchable_destinations.includes(
											taxTerm.name
										)
									) {
										// console.log(
										// 	lastTaxTitle,
										// 	taxTerm.name,
										// 	' check this'
										// );
										if (lastTaxTitle !== taxTerm.name) {
											lastTaxTitleDiv = taxTerm.name;
											lastTaxTitle = taxTerm.name;
										} else {
											lastTaxTitleDiv = '';
										}
										// console.log('includes ', taxTerm.name);
										return [
											<DestinationDiv
												name={lastTaxTitleDiv}
												key={'destination-' + index}
											/>,
											<DisplayCard
												post={post}
												theIndex={index}
												key={'card-' + index}
											/>,
										];
									}
								}
							});
						}
					})}
				</div>
			);
		} else if ('date' === state.sortBy) {
			// Availability from same source as trip page: wp-json/trip-finder/dates-rates (fetched in useEffect).
			const getAvailabilityLabel = (source) => {
				const tripType = source?.trip_info?.trip_type ?? '';
				if (CRUISE_TRIP_TYPES.includes(tripType)) {
					return 'Upon Request';
				}
				const tripId = source?.trip_info?.tripID;
				const depDate = source?.departure_time ? Moment.unix(source.departure_time).utc().format('YYYY-MM-DD') : '';
				const key = tripId != null && depDate ? `${tripId}_${depDate}` : '';
				const value = key ? availabilityMap[key] : null;
				if (availabilityLoading && value == null) return 'Loading…';
				return key ? (value || '—') : '—';
			};

			// console.log(posts, 'posts to sort');
			let selectedStartDateUnix;
			let selectedEndDateUnix;

			if (null !== state.selectedStartDate) {
				selectedStartDateUnix = new Date(state.selectedStartDate.format('MM/DD/Y') + ' UTC').getTime() / 1000;
			} else {
				selectedStartDateUnix = Math.floor(Date.now() / 1000);
			}

			if (null !== state.selectedEndDate) {
				selectedEndDateUnix = new Date(state.selectedEndDate.format('MM/DD/Y') + ' UTC').getTime() / 1000;
			}

			const sortedPosts = posts.sort(
				(a, b) => a._source.departure_time - b._source.departure_time
			);
			// console.log('sorted', sortedPosts);

			return (
				<div className="wp-block-table">
					<table className="has-fixed-layout trip-finder__table">
						<thead>
							<tr>
								<th>Date</th>
								<th>Trip</th>
								<th>Availability</th>
							</tr>
						</thead>

						<tbody>
							{sortedPosts.map((sortedPost, index) => {
								const sortedPostSource = sortedPost._source;
								const timeString = formatDateString(sortedPostSource);
								const title = (sortedPostSource?.trip_title ?? '').replace(/&apos;|&#8217;/g, "’");
								const availabilityLabel = getAvailabilityLabel(sortedPostSource);
								
								return (
									<tr key={index}>
										<td>{timeString}</td>
										<td>
											<a
												href={
													sortedPostSource.trip_url
												}
											>
												{title}
											</a>
										</td>
										<td>
											<span className={
												availabilityLabel === 'Loading…'
													? 'trip-finder__availability trip-finder__availability--loading'
													: availabilityLabel.replace(/\s+/g, '-').toLowerCase() + ' trip-finder__availability'
											}>
												{availabilityLabel}
											</span>
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>
				</div>
			);
		}
		return (
			<div className="tf-posts other-trips extend-your-trip">
				{posts.map((post, index) => {
					return <DisplayCard post={post} theIndex={index} key={index} />;
				})}
			</div>
		);
	}
	return '';
}
